import React from 'react';
import { Link } from 'react-router-dom';

const AboutUs = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div
        className="py-14 px-6 text-white"
        style={{
          background: 'linear-gradient(135deg, #F06F6B 0%, #F07A5E 40%, #F58A54 100%)',
        }}
      >
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-2">About Us</h1>
          <p className="text-white/80 text-sm">Atlas Procurement Services, LLC DBA Stackd</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-12 space-y-10">

          {/* Who We Are */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Who We Are</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Stackd is a consumer research and comparison platform built to help people make smarter, more confident decisions on major purchases. We are operated by <strong>Atlas Procurement Services, LLC DBA Stackd</strong>, a company founded on the belief that consumers deserve better tools when it comes to researching, comparing, and choosing vendors, services, and financial products.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Our mission is simple: <strong>empower consumers to research, compare, and make informed decisions on major purchases</strong> — without the noise, pressure, or confusion that typically comes with the process.
            </p>
          </section>

          {/* The Problem We Solve */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">The Problem We Solve</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Major purchases — whether it's a home renovation, a new vehicle, a financial product, or a large service contract — are often stressful, time-consuming, and opaque. Consumers are left navigating dozens of websites, fielding unsolicited calls, and struggling to compare apples to apples across vendors with different pricing structures and terms.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Stackd was built to solve exactly that. We give consumers a single, organized place to research options, request quotes, compare vendors side by side, and track their decisions — all without the chaos.
            </p>
          </section>

          {/* How It Works */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">How It Works</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Stackd provides a structured workflow that guides consumers through the entire purchasing process:
            </p>
            <ul className="list-disc list-inside space-y-3 text-gray-700 pl-2 mb-4">
              <li><strong>Research:</strong> Explore vendors, products, and services relevant to your purchase category.</li>
              <li><strong>Request Quotes:</strong> Submit a single project request and receive quotes from multiple vendors.</li>
              <li><strong>Compare:</strong> Use our side-by-side comparison tools to evaluate vendors on price, scope, and fit.</li>
              <li><strong>Decide:</strong> Make an informed decision with all the information organized in one place.</li>
              <li><strong>Track:</strong> Monitor project milestones and vendor communications through completion.</li>
            </ul>
            <p className="text-gray-700 leading-relaxed">
              Stackd does not sell products or services directly, and we do not act as an agent or broker for any vendor. We are a neutral platform designed to put the consumer in control.
            </p>
            <div className="mt-4">
              <Link
                to="/how-it-works"
                className="inline-block text-sm font-semibold px-5 py-2.5 rounded-lg text-white transition-opacity hover:opacity-90"
                style={{ background: 'linear-gradient(135deg, #F06F6B 0%, #F58A54 100%)' }}
              >
                See How It Works →
              </Link>
            </div>
          </section>

          {/* Company Background */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Our Company</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Stackd is operated by <strong>Atlas Procurement Services, LLC</strong>, doing business as Stackd. We are a US-based company focused on building technology that simplifies the consumer purchasing journey.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              The platform is designed for US residents and is intended to serve consumers across a wide range of purchase categories — from home services and major appliances to financial products and beyond.
            </p>
            <p className="text-gray-700 leading-relaxed">
              We believe that transparency, simplicity, and consumer empowerment should be at the center of every major purchase decision. That belief drives everything we build.
            </p>
          </section>

          {/* Contact / CTA */}
          <section className="rounded-xl p-8 text-center" style={{ background: 'linear-gradient(135deg, #FFF5F4 0%, #FFF0EB 100%)', border: '1px solid #FDDDD9' }}>
            <h2 className="text-2xl font-bold text-gray-900 mb-3">Get in Touch</h2>
            <p className="text-gray-600 leading-relaxed mb-6 max-w-xl mx-auto">
              Have questions about Stackd, partnership opportunities, or just want to learn more? We'd love to hear from you.
            </p>
            <a
              href="mailto:info@saveonstackd.com"
              className="inline-block text-sm font-semibold px-6 py-3 rounded-lg text-white transition-opacity hover:opacity-90"
              style={{ background: 'linear-gradient(135deg, #F06F6B 0%, #F58A54 100%)' }}
            >
              Contact Us: info@saveonstackd.com
            </a>
          </section>

        </div>
      </div>
    </div>
  );
};

export default AboutUs;
